import { render, staticRenderFns } from "./Wp_nav_bar.vue?vue&type=template&id=1b2aa649&scoped=true&"
import script from "./Wp_nav_bar.vue?vue&type=script&lang=js&"
export * from "./Wp_nav_bar.vue?vue&type=script&lang=js&"
import style0 from "./Wp_nav_bar.vue?vue&type=style&index=0&id=1b2aa649&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2aa649",
  null
  
)

export default component.exports